import{jsx as r,jsxs as a}from"react/jsx-runtime";import e from"react";import t from"./AnalyticsContext";import o from"./LocationTracker";import i from"./useAnalytics";/** Provides Firefly Internal Insights configuration to child `useAnalytics`/`withAnalytics` calls.
 * Provides automated route tracking when enabled with `trackLocations`.
 *
 * @param trackLocations Automatically send page load / route change events to Firefly Internal Insights.
 * @param eventManagerConfiguration Configuration values for creating a Firefly Event Manager.
 * @example
 * const App = () => {
 *   return (
 *     <Router>
 *       <AnalyticsProvider
 *         eventManagerConfiguration={apiConfig.analytics}
 *         trackLocations
 *       >
 *         <Home />
 *       </AnalyticsProvider>
 *     </Router>
 *   )
 * }
 */const n=({children:e,trackLocations:n,eventManagerConfiguration:m})=>{if(!m){throw new Error(`'<AnalyticsProvider>' Event manager configuration was not defined. Properties 'apiKey' and 'appName' must contain a value`)}if(!m.apiKey||!m.appName){throw new Error(`'<AnalyticsProvider>' Event manager configuration was formatted incorrectly. Properties 'apiKey' and 'appName' must contain a value`)}const s=i(m);return /*#__PURE__*/a(t.Provider,{value:s,children:[n&&/*#__PURE__*/r(o,{}),e]})};export default n;